import * as Yup from 'yup';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Link, Stack, Alert, Typography, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import FormProvider, { RHFTextField } from '../../../components/hook-form';


export default function MFAEnrollPhoneForm(params){
    const {setPhone, sendVerifyPhoneCode} = params;
    const defaultValues = {
        phone: '',
    };
    const VerifyCodeSchema = Yup.object().shape({
        phone: Yup.string().required('Phone number is required'),
      });
    
    const methods = useForm({
        resolver: yupResolver(VerifyCodeSchema),
        defaultValues,
    });
    
    const {
        reset,
        setError,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = methods;

    const onSubmit = async(data) => {
        console.log(data);
        setPhone(data.phone);
        sendVerifyPhoneCode(data.phone);
    }

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
                <Typography variant="h4">
                    Enter the Cell Phone Number 
                    (Including Country Code) 
                    you would like to use with Multi-Factor Authentication.
                </Typography>
            </Stack>
            <Stack sx={{mb:2}}>
                <RHFTextField name="phone" label="Phone Number" />
            </Stack>
            <LoadingButton
			fullWidth
			color="inherit"
			size="large"
			type="submit"
			variant="contained"
			loading={isSubmitSuccessful || isSubmitting}
			sx={{
			bgcolor: 'text.primary',
			color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
			'&:hover': {
				bgcolor: 'text.primary',
				color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
			},
			}}
            >
                Next
            </LoadingButton>
        </FormProvider >
    )
}